import Uploader from 'components/Helper/Uploader';
import config from 'config';
import { useState } from 'react';
import { useAppDispatch } from 'reducer';
import { errorAlert, successAlert } from 'reducer/slices/alertSlice';
import { hideLoading, showLoading } from 'reducer/slices/loadingSlice';
import { hidePopup } from 'reducer/slices/popupSlice';
import gather from 'tools/gather';

const Add = ({ data = undefined, reload }: any) => {
  const dispatch = useAppDispatch();
  const [title, setTitle] = useState(data?.title);
  const [type, setType] = useState(data?.type);
  const [file, setFile] = useState(data?.file);

  const submit = async () => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/v1/admin/story${data ? '/' + data._id : ''}`, true)[data ? 'put' : 'post']({
      title: title,
      type: type,
      file: file,
    });

    if (result.code === 200) {
      dispatch(hidePopup());
      dispatch(successAlert('Done!'));
      reload();
    } else {
      dispatch(errorAlert(result.message ?? 'Not connected to server'));
    }

    dispatch(hideLoading());
  };

  return (
    <div className='login'>
      <div className='inputLogin'>
        <span>Title</span>
        <input type='text' value={title} onChange={(e) => setTitle(e.target.value)} />
      </div>
      <div className='inputLogin'>
        <span>Side</span>
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value=''>Select</option>
          <option value='image'>Image</option>
          <option value='video'>Video</option>
        </select>
      </div>
      <div className='inputLogin'>
        <span>File (Image/Video)</span>
        <input type='text' value={file} />
      </div>
      <Uploader setUrl={setFile} url={file} name='fileImage' types={['JPG', 'PNG', 'JPEG']} />
      <div className='submit' onClick={() => submit()}>
        Submit
      </div>
    </div>
  );
};

export default Add;
